// extracted by mini-css-extract-plugin
module.exports = {"root":"SchoolSelect_root__3iacl","schoolSelector":"SchoolSelect_schoolSelector__3NGC7","buttons":"SchoolSelect_buttons__3WO3D"};